import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Head from "../components/Head";
import auth from '../utils/auth';
import '../styles/LoginPage.css';
import { scrollToTop } from '../hooks/useScrollToTop';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (auth.isAuthenticated()) {
      navigate('/');
      scrollToTop();
    }
  }, [navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');

    if (!email || !password) {
      setError('Alla fält är obligatoriska.');
      return;
    }

    const emailRegex = /^[\w-\\.]+@([\w-]+\.)+[\w-]{2,4}$/gi;
    if (!emailRegex.test(email)) {
      setError('Ange en giltig e-postadress.');
      return;
    }

    if (password.length < 6) {
      setError('Lösenordet måste vara minst 6 tecken långt.');
      return;
    }

    try {
      const loginResponse = await fetch(`${process.env.REACT_APP_API_BASE_URL}/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ email, password })
      });

      const loginData = await loginResponse.json();

      if (loginResponse.status !== 200) {
        setError(loginData.message || 'Ett fel inträffade vid inloggning.');
        return;
      }

      auth.login(loginData.token, loginData.user);
      navigate('/');
      scrollToTop();
    } catch (error) {
      setError(error.message || 'Serverfel. Försök igen.');
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="login-page">
      <Head title="EssayWriter | Logga in" />
      <div className="login-container">
        <h2 className="login-title">Logga in</h2>
        {error && <p className="login-error">{error}</p>}
        <form onSubmit={handleLogin} className="login-form">
          <div className="login-form-group">
            <label htmlFor="email" className="login-label">E-post:</label>
            <input
              type="email"
              id="email"
              className="login-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="login-form-group">
            <label htmlFor="password" className="login-label">Lösenord:</label>
            <div className="login-password-input-container">
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                className="login-input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <button 
                type="button" 
                className="login-password-toggle-btn" 
                onClick={togglePasswordVisibility}
              >
                {showPassword ? "Dölj" : "Visa"}
              </button>
            </div>
            <div className="forgot-password-link">
              <a href="/glomt-losenord">Glömt lösenord?</a>
            </div>
          </div>
          <button type="submit" className="login-button">Logga in</button>
        </form>
        <p className="login-register-link">
          Har du inget konto? <a href="/registrera">Registrera dig</a>
        </p>
      </div>
    </div>
  );
};

export default LoginPage;